(function () {
  var TYPING_SPEED   = 80;   // ms per character while typing
  var DELETING_SPEED = 40;   // ms per character while deleting
  var PAUSE_TYPED    = 1800; // ms pause after fully typed
  var PAUSE_DELETED  = 400;  // ms pause after fully deleted

  function getTexts(el) {
    // Per-element override via data attribute (legacy support)
    var attr = el.dataset.typewriterTexts;
    if (attr && attr.trim()) {
      return attr.split(/\r?\n|\|/).map(function (s) { return s.trim(); }).filter(Boolean);
    }
    // Global setting from theme
    var global = window.navyadSearchPlaceholders;
    if (global && global.trim()) {
      return global.split(/\r?\n|\|/).map(function (s) { return s.trim(); }).filter(Boolean);
    }
    return [];
  }

  function startTypewriter(el) {
    if (el._typewriterInit) return;
    el._typewriterInit = true;

    var texts = getTexts(el);
    if (!texts.length) return;

    var isInput    = el.tagName === 'INPUT';
    var textIndex  = 0;
    var charIndex  = 0;
    var isDeleting = false;
    var timer      = null;
    var paused     = false;

    function setText(text) {
      if (isInput) {
        el.placeholder = text;
      } else {
        el.textContent = text;
      }
    }

    function tick() {
      if (paused) return;
      var current = texts[textIndex];

      if (isDeleting) {
        charIndex--;
        setText(current.substring(0, charIndex));

        if (charIndex === 0) {
          isDeleting = false;
          textIndex  = (textIndex + 1) % texts.length;
          timer = setTimeout(tick, PAUSE_DELETED);
        } else {
          timer = setTimeout(tick, DELETING_SPEED);
        }
      } else {
        charIndex++;
        setText(current.substring(0, charIndex));

        if (charIndex === current.length) {
          isDeleting = true;
          timer = setTimeout(tick, PAUSE_TYPED);
        } else {
          timer = setTimeout(tick, TYPING_SPEED);
        }
      }
    }

    function resume() {
      paused     = false;
      charIndex  = 0;
      isDeleting = false;
      timer = setTimeout(tick, 600);
    }

    if (isInput) {
      // Pause while focused (user is typing), resume on blur if empty
      el.addEventListener('focus', function () {
        paused = true;
        clearTimeout(timer);
      });
      el.addEventListener('blur', function () {
        if (el.value.trim() === '') {
          resume();
        }
      });
    } else {
      // For label spans: pause when parent m-search-popup opens, resume when it closes
      var popup = el.closest('m-search-popup');
      if (popup) {
        new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            if (m.attributeName === 'open') {
              if (popup.hasAttribute('open')) {
                paused = true;
                clearTimeout(timer);
              } else {
                resume();
              }
            }
          });
        }).observe(popup, { attributes: true });
      }
    }

    timer = setTimeout(tick, 1200);
  }

  function initAll() {
    document.querySelectorAll('input[type="search"]').forEach(startTypewriter);
    document.querySelectorAll('.m-search-form__label').forEach(startTypewriter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-scan when search popup opens (inputs may be dynamically revealed)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-search-popup]')) {
      setTimeout(initAll, 300);
    }
  });
})();
